const releaseStatuses = {
  id: "releaseStatuses",
  label: "Release Statuses",
  endpoint: "release_statuses",
  columnConfig: [
    {
      field: "name",
      headerName: "Release Status",
      width: 250,
      description: "Release Status",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default releaseStatuses;
